import styled, { keyframes } from 'styled-components'
import { tokens } from '../../../assets/tokens'

const { color } = tokens

const animateIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

const animateOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-20px);
  }
`

// Cada fase o estado es un bloque limpio: fondo blanco solo para separarlo del gris de la página
const ListItemStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .dragHandle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    min-height: 48px;
    padding: 4px 8px 4px 12px;
    box-sizing: border-box;
    background-color: ${color.background.default};
    border: 1px solid ${color.border.subtle};
    border-radius: 10px;
    outline: none;
  }

  .listItem {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    min-width: 0;
    flex: 1;
    animation: ${animateIn} 0.2s ease-in-out;
    &.listItem-exit {
      animation: ${animateOut} 0.2s ease-in-out;
    }
  }

  .dragIcon,
  .lockIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .dragIcon {
    cursor: grab;
    touch-action: none;
  }

  .colorDot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-family: ${tokens.typography.fontFamily.primary};
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${color.text.secondary};
    user-select: none;
  }
`

export default ListItemStyled
